import { render, staticRenderFns } from "./ProcedureAffidamento.vue?vue&type=template&id=3de1e5dc&"
import script from "./ProcedureAffidamento.vue?vue&type=script&lang=js&"
export * from "./ProcedureAffidamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports